export default {
  title: 'Kontrola rejstříků',
  lastCheckTitle: 'Poslední kontrola',
  historyOfControlTitle: 'Historie kontrol',

  lastCheck: {
    planned: 'Naplánováno',
    plannedNote: 'kontrola proběhne v následujících dnech',
  },

  history: {
    emptyTitle: 'Zatím tu nejsou žádné záznamy kontrol',
    emptyText:
      'Katastr nemovitostí, rejstřík společenství, insolvenční rejstřík i registr plátců DPH za vás pravidelně kontrolujeme. Výsledky kontrol a všechny zjištěné změny najdete zde.',
  },

  notificationSettings: {
    title: 'E-mailové notifikace',
    changeLabel: 'Zasílat mi okamžité upozornění, když zjistíme změnu v rejstřících',
    reportLabel: 'Zasílat mi pravidelný měsíční souhrn monitoringu',
    note: 'Nastavení platí jen pro vás, ostatní správci si ho řídí sami. Odhlásit odběr můžete i odkazem přímo v doručeném e-mailu.',
    successOn: 'E-maily jsou zapnuté.',
    successOff: 'E-maily jsou vypnuté.',
    error: 'Něco se nepovedlo. Zkuste to prosím znovu.',
  },
};
